import { dateId, searchId, segmentDisplayId } from "@/assets/googleTrackIds";
import { FiltersButton } from "@/components/Dataheader/FiltersButton";
import { FiltersDrawer } from "@/components/Dataheader/FiltersDrawer";
import { FC, useEffect, useState } from "react";
import qs from "query-string";
import { useLocation, useNavigate } from "react-router-dom";
import { DataHeader, DatePicker, Flex, Form, Grid, Input, Segmented, Typography } from "@payping/web-components";
import { submitQueryParams } from "@payping/utils/query-string";
import { PhRList, PhRSquaresFour } from "@payping/icons";
import { dateFormats, toUtc } from "@payping/utils/dateUtils";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { RequestListStringQueryParamsType } from "./types";

interface Props {
  retry: () => void;
  loading?: boolean;
}

export const RequestListFilters: FC<Props> = (props) => {
  const { retry, loading } = props;
  const { t } = useAppTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [openDrawer, setOpenDrawer] = useState(false);
  const [form] = Form.useForm();
  const parsedSearch = qs.parse(location.search, {
    arrayFormat: "bracket",
  });
  const { lg } = Grid.useBreakpoint();
  const { code, submittedTimeFrom, submittedTimeTo, segment }: RequestListStringQueryParamsType = qs.parse(
    location.search,
    {
      arrayFormat: "bracket",
    },
  );
  const backFormat = dateFormats.standard.utcDateTime;

  useEffect(() => {
    form.setFieldsValue({
      code,
      submittedTime: [
        toUtc({ date: submittedTimeFrom, dateFormat: backFormat, toFormat: backFormat }).object || null,
        toUtc({ date: submittedTimeTo, dateFormat: backFormat, toFormat: backFormat }).object || null,
      ],
    });
  }, [backFormat, code, form, submittedTimeFrom, submittedTimeTo]);

  const mobileFiltersBadgeCount = !lg ? { code, submittedTimeTo } : undefined;

  return (
    <Form
      key={1}
      onFinish={(values): void => {
        const date = values.submittedTime || [undefined, undefined];
        const [from, to] = [
          date[0]?.format(dateFormats.standard.utcDateTime),
          date[1]?.format(dateFormats.standard.utcDateTime),
        ];
        const newValues = {
          code: values.code,
          submittedTimeFrom: from || undefined,
          submittedTimeTo: to || undefined,
        };
        submitQueryParams({
          navigate,
          newValues,
          parsedSearch,
          pathname: location.pathname,
          retry,
        });
        setOpenDrawer(false);
      }}
      form={form}
      name={"filter"}
    >
      <DataHeader
        title={
          <Typography.Title className={"!tw-m-0"} level={4}>
            {t("settlement.report.requestList")}
          </Typography.Title>
        }
        filters={{
          segmentsButton: (
            <Segmented
              key={0}
              value={segment}
              onChange={(value) =>
                submitQueryParams({
                  navigate,
                  newValues: { segment: value },
                  parsedSearch: {},
                  pathname: location.pathname,
                  retry,
                })
              }
              options={[
                {
                  value: "settlement",
                  icon: <PhRList width={16} />,
                  label: t("settlement.report.title"),
                },
                {
                  value: "request",
                  icon: <PhRSquaresFour width={16} />,
                  label: t("settlement.requestsReport"),
                },
              ]}
              data-google-track={segmentDisplayId}
            />
          ),
          datepickerInput: (
            <Form.Item key={1} noStyle name="submittedTime">
              <DatePicker.RangePicker
                className={"tw-w-full"}
                allowClear
                onChange={() => form.submit()}
                data-google-track={dateId}
              />
            </Form.Item>
          ),
          searchbarInput: (
            <Form.Item key={2} noStyle name={"code"}>
              <Input.Search
                loading={loading}
                placeholder={t("settlement.code")}
                onSearch={() => form.submit()}
                allowClear
                data-google-track={searchId}
              />
            </Form.Item>
          ),
          filtersButton: !lg ? (
            <>
              <FiltersButton onClick={() => setOpenDrawer(true)} params={{ ...mobileFiltersBadgeCount }} />

              <FiltersDrawer
                title={t("filter")}
                onClose={() => setOpenDrawer(false)}
                open={openDrawer}
                onClickApplyFilters={() => form.submit()}
                onClickResetFilters={() => {
                  navigate({ pathname: location.pathname });
                  form.resetFields();
                  setOpenDrawer(false);
                }}
                loading={loading}
              >
                <Flex vertical gap={8}>
                  <>
                    {/* < DatePicker > */}
                    <Form.Item key={1} label={t("date")} name={"submittedTime"} layout={"vertical"}>
                      <DatePicker.RangePicker className="w-100" data-google-track={dateId} />
                    </Form.Item>

                    {/* < SearchVariant > */}
                    <Form.Item key={2} label={t("search.search")} name={"code"} layout={"vertical"}>
                      <Input placeholder={t("settlement.code")} allowClear data-google-track={searchId} />
                    </Form.Item>
                  </>
                </Flex>
              </FiltersDrawer>
            </>
          ) : null,
        }}
      />
    </Form>
  );
};
